<div
  class="progress-container"
  [class.increased-height]="previewMode && ((claimingStage !== null && claimingStage !== claimingStages.STAGE5) || incomplete?.length > 1)">
  <div class="complete-title">{{ 'csa.profile-completeness' | translate }}</div>
  <div class="mobile-title-container">
    <circle-progress
      class="rating-circle"
      [outerStrokeColor]="'#ffb607'"
      [outerStrokeWidth]="4"
      [innerStrokeWidth]="4"
      [space]="-4"
      [radius]="23.5"
      [percent]="completeness"></circle-progress>
    <div class="complete-title-mobile">{{ 'csa.your-profile' | translate }} {{ completeness }}% {{ 'csa.to-complete' | translate }}</div>
  </div>

  <ng-template #completed>
    <div class="percentage-complete">
      {{ 'csa.profile-completed' | translate }}
    </div>
  </ng-template>
  <ng-container>
    <div class="overall-results-box">
      <circle-progress class="rating-circle" [outerStrokeColor]="'#ffb607'" [percent]="completeness"></circle-progress>

      <div class="circle-content" [style.color]="'#ffb607'">
        <ng-container>
          <div>
            <span class="percentage-result">{{ this.completeness }}</span
            ><span class="percentage-style">%</span>
          </div>
        </ng-container>
      </div>
    </div>
    <div *ngIf="this.incomplete && this.incomplete.length" class="missing-items">
      <div class="still-missing">
        {{ 'csa.still-missing' | translate }}
      </div>
      <div class="missing-items-list">
        <ul>
          <li class="col-xs-12" *ngFor="let item of this.incomplete">
            <span class="text-missing-item" [ngx-scroll-to]="'#item'">{{ item | translate }}</span>
          </li>
        </ul>
      </div>
    </div>
    <button (click)="onClick()" class="update-profile-button mt-auto">{{ 'csa.progress-update-profile' | translate | uppercase }}</button>
  </ng-container>
</div>
